import { Youtube } from "lucide-react";

const VIDEO_ID = "oO85Ff9ZrGo"; // YouTube Short — vertical
const SPOTIFY_TRACK_ID = "49N5IoQvMo0nmwXZBUKvz0";
export const SPOTIFY_TRACK_URL = `https://open.spotify.com/track/${SPOTIFY_TRACK_ID}`;

export default function Music() {
  return (
    <section
      id="music"
      data-testid="music-section"
      className="relative py-28 md:py-40 lg:py-48 px-6 md:px-12 lg:px-20 ink-bg paper-grain"
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-14 lg:gap-x-16 items-end mb-14 md:mb-20">
          <div className="lg:col-span-7 reveal">
            <p className="text-[10px] uppercase tracking-[0.32em] text-teal mb-6">
              Featured · Music &amp; Video
            </p>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-ink">
              The first signal,
              <br />
              <em className="italic text-gold">on its way home.</em>
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 reveal">
            <p className="text-ink/70 font-light text-base md:text-lg leading-relaxed max-w-md">
              A glimpse of where the project is going. Stream the release
              on Spotify and follow along on YouTube to catch new music the
              moment it lands.
            </p>
          </div>
        </div>

        {/* Video frame with offset gold ink block behind */}
        <div className="relative reveal">
          <div
            aria-hidden="true"
            className="absolute -top-6 -left-6 md:-top-10 md:-left-10 w-[60%] h-full bg-gold/20"
          />
          <div
            aria-hidden="true"
            className="absolute -bottom-6 -right-6 md:-bottom-10 md:-right-10 w-[45%] h-2/3 bg-teal/15"
          />
          <div
            data-testid="video-frame"
            className="relative aspect-video w-full bg-ink overflow-hidden"
          >
            <iframe
              data-testid="youtube-iframe"
              src={`https://www.youtube.com/embed/${VIDEO_ID}?rel=0&modestbranding=1`}
              title="A Wider Horizon — featured video"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
            />
          </div>
        </div>

        {/* Spotify player embed */}
        <div className="mt-12 reveal" data-testid="spotify-embed-wrap">
          <iframe
            data-testid="spotify-iframe"
            style={{ borderRadius: "12px" }}
            src={`https://open.spotify.com/embed/track/${SPOTIFY_TRACK_ID}?utm_source=generator&theme=0`}
            title="A Wider Horizon — listen on Spotify"
            width="100%"
            height="152"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
          />
        </div>

        <div className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-5">
          <a
            data-testid="music-link-youtube"
            href="https://www.youtube.com/@awiderhorizonmusic"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.24em] text-ink hover:text-gold link-underline"
          >
            <Youtube strokeWidth={1.25} className="w-4 h-4" />
            Watch on YouTube
          </a>
          <a
            data-testid="music-link-spotify"
            href={SPOTIFY_TRACK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center text-[11px] uppercase tracking-[0.24em] text-ivory bg-ink hover:bg-teal px-6 py-3 transition-colors"
          >
            Listen on Spotify
          </a>
        </div>
      </div>
    </section>
  );
}
